export const fontSizes = {
  main: {
    normal: 38,
    extra: 20,
  },
  ynw: {
    normal: 38,
    extra: 20,
  },
  rng: {
    normal: 42,
    extra: 20,
  },
  rlg: {
    normal: 38,
    extra: 20,
  },
  rcg: {
    normal: 38,
    extra: 20,
    flagNormal: 50,
    flagExtra: 25,
  },
  rdg: {
    normal: 32,
    extra: 20,
  },
  mystery: {
    normal: 58,
    extra: 25,
  },
  icp: {
    normal: 38,
    extra: 20,
  },
  rcw: {
    normal: 38,
    extra: 20,
  },
  nfl: {
    normal: 38,
    extra: 20,
  },
  nba: {
    normal: 38,
    extra: 20,
  },
  rsg: {
    normal: 38,
    extra: 20,
  },
  mlb: {
    normal: 38,
    extra: 20,
  },
}
